<template>
  <div class="donation_content">
    <img class="donation_content_img" :src="returnImage()">
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";
import {runFileDown} from "@/mixins/fileApiDown"

export default {
  name: "DonationLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  props: {
    infoData: {},
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {

  },
  computed: {},
  methods: {
    returnImage() {
      return `${this.infoData.org_url}`;
    },

  },
  watch: {},
}
</script>

<style scoped>

</style>